import React from 'react';


const Section2 = ()=>{

    return(
            <div className="section2">
                <div className="row alumni m-0">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-wrap">
                        <div className="content">
                            <h1>
                                Board Of Directors
                            </h1>
                            <p>
                                As your one-stop shop for all things related to LUMS, we are committed to fostering your engagement with your alma mater and ensuring your participation in alumni activities. Whether it’s organizing more reunions around the world, hosting more mentorship sessions on campus, or promoting alumni success stories, we cannot move forward without you. Our alumni community is just as much a part of the LUMS story today than it ever has been before, and we are determined to facilitate your access to the University’s networks, resources, and events.
                            </p>
                            <p>
                                In this effort, we’d like to do our best to stay in touch with you the right way and keep you updated with all that is happening at LUMS. So how can you help us? Update your information in our alumni database! All you have to do is access your profile in the database, view your details, and make any necessary changes. Authenticating even as little as your basic contact information can help us go a long way in staying connected.
                            </p>
                            <div className="link">
                            <a href="/">
                                More <i className="fa fa-caret-right"></i>
                            </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-wrap">
                        <div className="row m-0 img-container">
                               <div className="col-12 img-section-1">
                                <div className="img-wrap">
                                    <img src="./images/home/1.jpg"   alt="" />
                                    <img src="./images/home/2.jpg"   alt="" />
                                </div>
                               </div>
                               <div className="col-12 img-section-1">
                               <div className="img-wrap">
                                    <img src="./images/home/3.jpg"   alt="" />
                                    <img src="./images/home/4.jpg"   alt="" />
                                    <img src="./images/home/5.jpg"   alt="" />
                                </div>
                                </div>
                                <div className="col-12 img-section-1">
                                <div className="img-wrap">
                                    <img src="./images/home/6.jpg"   alt="" />
                                    <img src="./images/home/7.jpg"   alt="" />
                                    <img src="./images/home/8.png"   alt="" />
                                </div>
                               </div> 
                                <div className="col-12 img-section-1">
                                <div className="img-wrap">
                                    <img src="./images/home/9.jpg"   alt="" />
                                    <img src="./images/home/10.jpg"   alt="" />
                                </div>
                                </div>    
                        </div>
                    </div>
                </div>
            </div>
        );

}

export default React.memo(Section2);